import { Box } from "@mui/material";
import { useCallback, useState } from "react";
import { FieldValues, Path } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { IFormStepperActionsProps } from "./models";
import { Button, useFormContext } from "@4uhub/lib4uhub";
import { genericMemo } from "../../../../../components/SubFormArray/genericMemo";

const FormStepperActions = <T extends FieldValues>({
  activeStep,
  isLastStep,
  canGoBack = true,
  finishLabel = "components.scheduleAssistant.newSchedule.sched"!,
  fieldToTriggerOnFinish,
  onBack,
  onNext,
  onFinish,
}: IFormStepperActionsProps) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);

  const { trigger } = useFormContext<T>();

  const onClickHandler = useCallback(async () => {
    if (isLastStep) {
      const valid = fieldToTriggerOnFinish
        ? await trigger(fieldToTriggerOnFinish as Path<T>)
        : true;
      if (!valid) return;
      setLoading(true);
      await onFinish();
      setLoading(false);
    } else {
      onNext();
    }
  }, [isLastStep, onFinish, onNext, trigger, fieldToTriggerOnFinish]);

  return (
    <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
      <Button
        color="inherit"
        disabled={activeStep === 0 || !canGoBack}
        onClick={onBack}
        sx={{ mr: 1 }}
      >
        {t("components.scheduleAssistant.newSchedule.back")}
      </Button>

      <Box sx={{ flex: "1 1 auto" }} />

      <Button onClick={onClickHandler} variant="contained" loading={loading}>
        {t(
          isLastStep
            ? finishLabel
            : "components.scheduleAssistant.newSchedule.next"
        )}
      </Button>
    </Box>
  );
};

export default genericMemo(FormStepperActions);
